import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Homepage2 } from './components/Homepage2';
import { Homepage } from './components/Homepage';
import { MagicHomepage } from './components/MagicHomepage';
import { AllCoursesPage } from './components/AllCoursesPage';
import { ContactPage } from './components/ContactPage';
import { CoursePage } from './components/CoursePage';
import { HACCPFoodSafetyPage } from './components/HACCPFoodSafetyPage';
import { HACCPFoodSafetyNewDesign } from './components/HACCPFoodSafetyNewDesign';
import { HACCPFoodSafetyPage3D } from './components/HACCPFoodSafetyPage3D';
import { HACCPLevel1Page } from './components/HACCPLevel1Page';
import { SEOTestPage } from './components/SEOTestPage';
import { MinimalCoursePage } from './components/MinimalCoursePage';
import { MinimalHomeIreland } from './components/MinimalHomeIreland';
export function AppRouter() {
  return <BrowserRouter data-id="element-14">
      <Routes data-id="element-15">
        <Route path="/" element={<App data-id="element-17" />} data-id="element-16" />
        <Route path="/home2" element={<Homepage2 data-id="element-19" />} data-id="element-18" />
        <Route path="/premium" element={<Homepage data-id="element-21" />} data-id="element-20" />
        <Route path="/magic" element={<MagicHomepage data-id="element-23" />} data-id="element-22" />
        <Route path="/minimal-home" element={<MinimalHomeIreland data-id="element-25" />} data-id="element-24" />
        <Route path="/courses" element={<AllCoursesPage data-id="element-27" />} data-id="element-26" />
        <Route path="/contact" element={<ContactPage data-id="element-29" />} data-id="element-28" />
        <Route path="/courses/food-safety-level-1" element={<CoursePage data-id="element-31" />} data-id="element-30" />
        <Route path="/courses/food-safety-level-1-ireland" element={<HACCPFoodSafetyPage data-id="element-33" />} data-id="element-32" />
        <Route path="/courses/food-safety-level-1-ireland-new" element={<HACCPFoodSafetyNewDesign data-id="element-35" />} data-id="element-34" />
        <Route path="/courses/food-safety-level-1-ireland-3d" element={<HACCPFoodSafetyPage3D data-id="element-37" />} data-id="element-36" />
        <Route path="/courses/haccp-level-1-ireland" element={<HACCPLevel1Page data-id="element-39" />} data-id="element-38" />
        <Route path="/seo-test" element={<SEOTestPage data-id="element-41" />} data-id="element-40" />
        <Route path="/courses/food-safety-level-1-ireland-minimal" element={<MinimalCoursePage data-id="element-43" />} data-id="element-42" />
      </Routes>
    </BrowserRouter>;
}